
import { CreateSessionUseCase } from "../../applications/usecase/create-session.usecase";
import { ListSessionUseCase } from "../../applications/usecase/list-session.usecase";
import { GetSessionUseCase } from "../../applications/usecase/get-session.usecase";
import { RealtimeReceiveMessage } from "../../../../common/services/realtime/realtime-receive-message";
import { RealtimeActions } from "../../../../common/services/realtime/realtime-actions";
import { RealtimePublishMessage } from "../../../../common/services/realtime/realtime-publish-message";
import { RealtimeEvents } from "../../../../common/services/realtime/realtime-events";
import { urlsPages } from "../../../../common/urls/urls-pages";
import { UrlUtils } from "../../../../config/utils/url-utils";
import { GetWorkoutUseCase } from "../../../workouts/application/usecases/get-workout.usecase";
import { ListActionsUseCase } from "../../../actions/application/usecases/list-actions.usecase";
import { SessionModel } from "../../applications/domain/session";
import { ListSessionInterface } from "./interface/list-session.interface";
import { CreateSessionParams } from "./interface/create-session.interface";


export class SessionController {
    static async createSession(param: CreateSessionParams): Promise<SessionModel> {
        const { workoutId, name, captureReactionTime } = param;
        return CreateSessionUseCase.execute(workoutId, name, captureReactionTime);
    }

    static async listSessions(param: ListSessionInterface): Promise<SessionModel[]> {
        try {
            const { workoutId, listReceiveMessage } = param;
            const sessions = await ListSessionUseCase.execute(workoutId);
            const firstSession = sessions.length > 0 ? sessions[0] : null;
            if (listReceiveMessage && firstSession) {
                await this.listenReceiveMessage(firstSession.id);
            }
            return sessions;
        } catch {
            throw Error("Erro ao listar sessões");
        }
    }

    static async getAllData(sessionId: string) {
        const session = await GetSessionUseCase.execute(sessionId);
        const [workout, actionsResult] = await Promise.all([
            GetWorkoutUseCase.execute(session.workoutId),
            ListActionsUseCase.execute(session.workoutId),
        ]);
        return { session, workout, actions: actionsResult.actions };
    }


    static async listenReceiveMessage(sessionId: string): Promise<void> {
        await RealtimeReceiveMessage.execute(sessionId, async (message) => {
            console.log("message", message);
            if (message.data === RealtimeActions.SESSION_SYN_ACK) {
                window.location.href = UrlUtils.goToPage(urlsPages.sessionExecution, sessionId);
            }
            if (message.data === RealtimeActions.SESSION_SYN) {
                await RealtimePublishMessage.execute(sessionId, RealtimeEvents.ACTION, RealtimeActions.SESSION_ACK);
            }
        });
    }

}